module.exports = __webpack_public_path__ + "img/changeCardExhibition.f48095e8.png";